export const countryCodes = [
	{ code: '+39', country: 'Italia', flag: '🇮🇹', label: '🇮🇹 Italia (+39)' },
	{ code: '+1', country: 'Stati Uniti / Canada', flag: '🇺🇸', label: '🇺🇸 Stati Uniti / Canada (+1)' },
	{ code: '+44', country: 'Regno Unito', flag: '🇬🇧', label: '🇬🇧 Regno Unito (+44)' },
	{ code: '+33', country: 'Francia', flag: '🇫🇷', label: '🇫🇷 Francia (+33)' },
	{ code: '+49', country: 'Germania', flag: '🇩🇪', label: '🇩🇪 Germania (+49)' },
	{ code: '+34', country: 'Spagna', flag: '🇪🇸', label: '🇪🇸 Spagna (+34)' },
	{ code: '+41', country: 'Svizzera', flag: '🇨🇭', label: '🇨🇭 Svizzera (+41)' },
	{ code: '+43', country: 'Austria', flag: '🇦🇹', label: '🇦🇹 Austria (+43)' },
	{ code: '+31', country: 'Paesi Bassi', flag: '🇳🇱', label: '🇳🇱 Paesi Bassi (+31)' },
	{ code: '+32', country: 'Belgio', flag: '🇧🇪', label: '🇧🇪 Belgio (+32)' },
	{ code: '+351', country: 'Portogallo', flag: '🇵🇹', label: '🇵🇹 Portogallo (+351)' },
	{ code: '+30', country: 'Grecia', flag: '🇬🇷', label: '🇬🇷 Grecia (+30)' },
	{ code: '+46', country: 'Svezia', flag: '🇸🇪', label: '🇸🇪 Svezia (+46)' },
	{ code: '+47', country: 'Norvegia', flag: '🇳🇴', label: '🇳🇴 Norvegia (+47)' },
	{ code: '+45', country: 'Danimarca', flag: '🇩🇰', label: '🇩🇰 Danimarca (+45)' },
	{ code: '+48', country: 'Polonia', flag: '🇵🇱', label: '🇵🇱 Polonia (+48)' },
	{ code: '+420', country: 'Repubblica Ceca', flag: '🇨🇿', label: '🇨🇿 Repubblica Ceca (+420)' },
	{ code: '+36', country: 'Ungheria', flag: '🇭🇺', label: '🇭🇺 Ungheria (+36)' },
	{ code: '+40', country: 'Romania', flag: '🇷🇴', label: '🇷🇴 Romania (+40)' },
	{ code: '+7', country: 'Russia', flag: '🇷🇺', label: '🇷🇺 Russia (+7)' },
	{ code: '+86', country: 'Cina', flag: '🇨🇳', label: '🇨🇳 Cina (+86)' },
	{ code: '+81', country: 'Giappone', flag: '🇯🇵', label: '🇯🇵 Giappone (+81)' },
	{ code: '+82', country: 'Corea del Sud', flag: '🇰🇷', label: '🇰🇷 Corea del Sud (+82)' },
	{ code: '+91', country: 'India', flag: '🇮🇳', label: '🇮🇳 India (+91)' },
	{ code: '+61', country: 'Australia', flag: '🇦🇺', label: '🇦🇺 Australia (+61)' },
	{ code: '+55', country: 'Brasile', flag: '🇧🇷', label: '🇧🇷 Brasile (+55)' },
	{ code: '+52', country: 'Messico', flag: '🇲🇽', label: '🇲🇽 Messico (+52)' },
	{ code: '+54', country: 'Argentina', flag: '🇦🇷', label: '🇦🇷 Argentina (+54)' },
	{ code: '+27', country: 'Sud Africa', flag: '🇿🇦', label: '🇿🇦 Sud Africa (+27)' },
	{ code: '+20', country: 'Egitto', flag: '🇪🇬', label: '🇪🇬 Egitto (+20)' },
	{ code: '+971', country: 'Emirati Arabi Uniti', flag: '🇦🇪', label: '🇦🇪 Emirati Arabi Uniti (+971)' }
]
